const MuiListSubheader = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.text.primary
            })
    }
};
export { MuiListSubheader };

//# sourceMappingURL=list-subheader.js.map